import { sectionRenderer } from '@theme/section-renderer';
import { onDocumentReady, requestIdleCallback } from '@theme/utilities';

const RESILIENT_SECTION_SELECTOR = '[data-crs-cache-resilient-section]';
const VALID_SECTION_ID = /^[a-zA-Z0-9_-]+$/;

/**
 * Refreshes opt-in static content from the current published theme.
 * The server-rendered section remains the fallback if the request fails.
 *
 * @param {HTMLElement} sectionRoot
 */
async function refreshSection(sectionRoot) {
  const sectionId = sectionRoot.dataset.crsCacheSectionId;

  if (!sectionId || !VALID_SECTION_ID.test(sectionId)) return;

  const refreshUrl = new URL(window.location.href);
  refreshUrl.searchParams.delete('section_id');
  refreshUrl.searchParams.delete('sections');
  refreshUrl.searchParams.set('_crs_section_refresh', Date.now().toString());

  try {
    await sectionRenderer.renderSection(sectionId, {
      cache: false,
      mode: 'full',
      url: refreshUrl,
    });

    const wrapper = document.getElementById(`shopify-section-${sectionId}`);
    if (wrapper) wrapper.dataset.crsCacheRefreshed = 'true';
  } catch {
    // Keep the complete server-rendered fallback when refresh is unavailable.
  }
}

function refreshOptInSections() {
  if (window.Shopify?.designMode) return;
  if (new URL(window.location.href).searchParams.has('section_id')) return;

  for (const sectionRoot of document.querySelectorAll(RESILIENT_SECTION_SELECTOR)) {
    if (!(sectionRoot instanceof HTMLElement)) continue;
    refreshSection(sectionRoot);
  }
}

onDocumentReady(() => {
  requestIdleCallback(refreshOptInSections);
});
